import { lazy } from 'react';

export const ReportsPageSavingsSummaryAsync = lazy(
    () => import('./ReportsPageSavingsSummary'),
);
